// extracted by mini-css-extract-plugin
module.exports = {"backgroundpic":"doctorappointments_backgroundpic__3o1SZ","allapt":"doctorappointments_allapt__1uw9R"};